import { render, staticRenderFns } from "./Declines.vue?vue&type=template&id=6563ee82&scoped=true&"
import script from "./Declines.vue?vue&type=script&lang=js&"
export * from "./Declines.vue?vue&type=script&lang=js&"
import style0 from "./Declines.vue?vue&type=style&index=0&id=6563ee82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6563ee82",
  null
  
)

export default component.exports